import { render, staticRenderFns } from "./stage_sale_price_version.vue?vue&type=template&id=2559279e&"
import script from "./stage_sale_price_version.vue?vue&type=script&lang=js&"
export * from "./stage_sale_price_version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports